import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageHeader from "../../../../components/PageHeader";
import HowItWorksButton from "../../../../components/howItWorks/HowItWorksButton";
import Clients from "../../client/Clients";
import ImportClientsModal from "../../client/ImportClientsModal";

const SettingsClientsList = ({ token, API, basePath }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [showImportModal, setShowImportModal] = useState(false);
  const [listRefreshKey, setListRefreshKey] = useState(0);

  return (
    <div className="settings-page-wrapper">
      <PageHeader
        title={t("settingsClients.pageTitle")}
        showBackButton={true}
        backRoute="/settings"
        backLabel={t("settingsClients.backToSettings")}
        helpButton={<HowItWorksButton topic="wasteOrigins" />}
      />
      <div className="settings-content-wrapper">
        <div className="settings-list-shell">
          <Clients
            token={token}
            API={API}
            basePath={basePath}
            refreshKey={listRefreshKey}
            onCreateClient={() => history.push(`${basePath}/new`)}
            onImportClients={() => setShowImportModal(true)}
            onOpenClient={(client) => history.push(`${basePath}/${client._id}`)}
          />
        </div>
      </div>
      <ImportClientsModal
        isOpen={showImportModal}
        onClose={() => setShowImportModal(false)}
        onImported={() => setListRefreshKey((key) => key + 1)}
      />
    </div>
  );
};

export default SettingsClientsList;
